import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import "react-toastify/dist/ReactToastify.css";
const theme = createTheme(); // or customize

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider theme={theme}>
  <BrowserRouter>
    <CssBaseline />
    <App />
  </BrowserRouter>
</ThemeProvider>

    
);